<template>
  <div class="stats">
    <div class="stats__row">
      <div class="stats__cell">
        <figure class="stats__logo">
          <img src="../assets/img/logo_auction.svg">
        </figure>
      </div>
      <div class="stats__cell">
        <span class="stats__caption stats__large">
          <clock/>
        </span>
      </div>
      <template v-if="statsReady">
        <div
          v-if="stats.auctions"
          class="stats__cell">
          <span class="stats__caption">今まで開催された<br>総オークション数</span>
          <transition
            name="transition-counter"
            mode="out-in"
          >
            <span
              :key="stats.auctions || 0"
              class="stats__digit"
            >{{ amount(stats.auctions) || 0 }}</span>
          </transition>
        </div>
        <div
          v-if="stats.bids"
          class="stats__cell">
          <span class="stats__caption">今までの<br>総入札数</span>
          <transition
            name="transition-counter"
            mode="out-in"
          >
            <span
              :key="stats.bids || 0"
              class="stats__digit"
            >{{ amount(stats.bids) || 0 }}</span>
          </transition>
        </div>
      </template>
      <div
        v-else
        class="stats__cell">
        <loading-progress
          :indeterminate="true"
          :counter-clockwise="false"
          :hide-background="false"
          class="progress__line"
          size="200"
          width="200"
          height="2"
          shape="line"
          fill-duration="2"
          rotation-duration="1"
        />
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
.stats
  .vue-progress-path
    .background
      stroke: rgba(#000, 0.1)

    .progress
      stroke: rgba(#bf0000, 1)
</style>

<script>
import Clock from './elements/Clock';

export default {
  components: {
    Clock,
  },
  computed: {
    stats() {
      return this.$store.state.stats || {};
    },
    statsReady() {
      return ['error', 'ready'].includes(this.$store.state.statsStatus);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Stats.vue